import axiosInstance from '../shared/axiosInstance';
import { serviceConfig } from '../../config';
import { DealershipAdminRespV1 } from './types';

async function getDealershipAdmins(): Promise<DealershipAdminRespV1> {
  const url = `${serviceConfig.endpoints.legacy.root}${serviceConfig.endpoints.legacy.dealerships}/dealershipadmin`;
  let result = null;

  try {
    const response = await axiosInstance.get(url);
    result = response.data;
  } catch (err) {
    throw new Error('Error retriving getDealershipAdmins');
  }

  return result;
}

export default getDealershipAdmins;
